__turbopack_context__.v({
  "checkbox": "styles-module__giA0YG__checkbox",
  "checkboxGroup": "styles-module__giA0YG__checkboxGroup",
  "checkboxGroupError": "styles-module__giA0YG__checkboxGroupError",
  "checkboxLabel": "styles-module__giA0YG__checkboxLabel",
  "checkboxText": "styles-module__giA0YG__checkboxText",
  "contactForm": "styles-module__giA0YG__contactForm",
  "continueButton": "styles-module__giA0YG__continueButton",
  "inTouchSection": "styles-module__giA0YG__inTouchSection",
  "input": "styles-module__giA0YG__input",
  "inputError": "styles-module__giA0YG__inputError",
  "inputGroup": "styles-module__giA0YG__inputGroup",
  "leftBlock": "styles-module__giA0YG__leftBlock",
  "link": "styles-module__giA0YG__link",
  "messageContainer": "styles-module__giA0YG__messageContainer",
  "modalContent": "styles-module__giA0YG__modalContent",
  "modalTitle": "styles-module__giA0YG__modalTitle",
  "rightBlock": "styles-module__giA0YG__rightBlock",
  "submitButton": "styles-module__giA0YG__submitButton",
  "successIcon": "styles-module__giA0YG__successIcon",
  "title": "styles-module__giA0YG__title",
});
